package br.com.vvrefeicoes.portal.feature.operacional

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import br.com.vvrefeicoes.portal.core.ui.components.EmptyState
import br.com.vvrefeicoes.portal.feature.shell.LocalGlobalFilters
import br.com.vvrefeicoes.portal.feature.shell.LocalGlobalPeriod
import org.jetbrains.compose.resources.stringResource
import portalvv.shared.generated.resources.Res
import portalvv.shared.generated.resources.operational_directors_empty

@Composable
fun DirectorsContent() {
    val controller = rememberDirectorsController()
    val filters = LocalGlobalFilters.current
    val period = LocalGlobalPeriod.current

    LaunchedEffect(controller) {
        controller.init()
    }

    LaunchedEffect(period.selection) {
        controller.applyPeriod(period.selection)
    }

    LaunchedEffect(filters.unit, filters.director, filters.units) {
        controller.applyFilter(filters.selectedUnit, filters.selectedDirector, filters.units)
    }

    when {
        controller.loading ->
            Box(
                modifier = Modifier.fillMaxWidth().height(200.dp),
                contentAlignment = Alignment.Center,
            ) {
                CircularProgressIndicator()
            }
        controller.directors.isEmpty() ->
            EmptyState(message = stringResource(Res.string.operational_directors_empty))
        else -> EntityFinancialsGrid(items = controller.directors)
    }
}
